export const catalog = {
  title: "الفهرس",
  description: "المنتجات ومراكز العمل والمواد التي تغذي التسعير والتخطيط.",
  buttons: {
    workCenter: "مركز عمل",
    material: "مادة",
    product: "منتج",
  },
  sections: {
    workCenters: "مراكز العمل",
    materials: "المواد",
    products: "المنتجات",
  },
  column: {
    code: "الرمز",
    name: "الاسم",
    hourlyRate: "الأجر بالساعة",
    sku: "SKU",
    unit: "الوحدة",
    standardCost: "التكلفة القياسية",
    revision: "المراجعة",
    actions: "إجراءات",
  },
  revision: {
    released: "صادر",
    noRevision: "بدون مراجعة",
    addRevision: "إضافة مراجعة",
  },
  workCenter: {
    addTitle: "إضافة مركز عمل",
    saved: "حفظ مركز العمل",
    addedToast: "تمت إضافة مركز العمل",
    rateHint: "يُستخدم لتقدير وقت مركز العمل.",
  },
  material: {
    addTitle: "إضافة مادة",
    saved: "حفظ المادة",
    addedToast: "تمت إضافة المادة",
    costHint: "لكل وحدة، ويُستخدم للتقدير.",
  },
  product: {
    addTitle: "إضافة منتج",
    saved: "حفظ المنتج",
    addedToast: "تمت إضافة المنتج",
  },
  productRevision: {
    title: "إنشاء مراجعة منتج",
    description: "تغذي المسارات وقائمة المواد تقديرات عرض الأسعار لهذا المنتج.",
    releaseRevision: "إصدار المراجعة",
    releasedToast: "تم إصدار المراجعة",
    routing: "المسار",
    addStep: "إضافة خطوة",
    none: "لا شيء",
    stepDescription: "وصف الخطوة",
    setupMin: "التجهيز (دقيقة)",
    runMinPerUnit: "دقيقة التشغيل لكل وحدة",
    bom: "قائمة المواد",
    addMaterial: "إضافة مادة",
    qtyPerUnit: "الكمية لكل وحدة",
    scrapFactor: "عامل الهالك",
  },
};
